import RpacScan from './RpacScan'

export default RpacScan